module.exports = __webpack_public_path__ + "static/Tasks_app_screen-ba75f21445cc0f368f70bc8066bc5ee3.png";